export default __webpack_public_path__ + "static/media/info-institu.f3355cff.svg";